import { ScheduleViewMode } from '@/lib/enum/schedule-v2/ScheduleViewMode';

const defaultView = ScheduleViewMode.Week;
const defaultDate = new Date();

export default {
  namespaced: true,

  state: {
    date: defaultDate,
    view: defaultView,
  },

  mutations: {
    SET_DATE(state, date: Date) {
      state.date = date;
    },
    SET_View(state, view: ScheduleViewMode) {
      state.view = view;
    },
  },

  actions: {
    setDate({ commit }, date: Date) {
      commit('SET_DATE', date);
    },
    setView({ commit }, view: ScheduleViewMode) {
      commit('SET_View', view);
    },
  },
};
